'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.authSagas = authSagas;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _authReducer = require('../reducer/auth-reducer');

var _authHelpers = require('../services/auth-helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(initializeAuth),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(pollLoginState),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(completeSuccessfulLogin),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(login),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(refreshUser),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(updateUser),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(logout),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(authSagas);

function initializeAuth() {
  var loginCookie, loginInfo, storageName, storedLoginInfo, tullyHost, tokenResponse, sirenHost, productRightsReponse;
  return _regenerator2.default.wrap(function initializeAuth$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_authHelpers.getLoginCookie);

        case 2:
          loginCookie = _context.sent;

          if (!(!loginCookie || !loginCookie.userId || !loginCookie.access_token)) {
            _context.next = 9;
            break;
          }

          _context.next = 6;
          return (0, _effects.call)(logout);

        case 6:
          _context.next = 8;
          return (0, _effects.put)(_authReducer.authActions.initComplete());

        case 8:
          return _context.abrupt('return', _context.sent);

        case 9:
          _context.prev = 9;
          loginInfo = null;
          _context.next = 13;
          return (0, _effects.select)(_authReducer.authSelectors.appId);

        case 13:
          storageName = _context.sent;
          _context.next = 16;
          return (0, _effects.call)(_authHelpers.getStoredLoginInfo, storageName);

        case 16:
          storedLoginInfo = _context.sent;

          if (!(storedLoginInfo && storedLoginInfo.userId === loginCookie.userId && storedLoginInfo.access_token === loginCookie.access_token)) {
            _context.next = 21;
            break;
          }

          loginInfo = storedLoginInfo;
          _context.next = 36;
          break;

        case 21:
          _context.next = 23;
          return (0, _effects.select)(_authReducer.authSelectors.tullyHost);

        case 23:
          tullyHost = _context.sent;
          _context.next = 26;
          return (0, _effects.call)(_authHelpers.getAccessTokenData, loginCookie.access_token, tullyHost);

        case 26:
          tokenResponse = _context.sent;
          _context.next = 29;
          return (0, _effects.select)(_authReducer.authSelectors.sirenHost);

        case 29:
          sirenHost = _context.sent;
          _context.next = 32;
          return (0, _effects.call)(_authHelpers.getProductRights, tokenResponse.userId, tokenResponse.access_token, sirenHost);

        case 32:
          productRightsReponse = _context.sent;
          _context.next = 35;
          return (0, _effects.call)(_authHelpers.saveStoredLoginInfo, storageName, tokenResponse, productRightsReponse.productRights);

        case 35:
          loginInfo = _context.sent;

        case 36:
          _context.next = 38;
          return (0, _effects.call)(completeSuccessfulLogin, loginInfo);

        case 38:
          _context.next = 44;
          break;

        case 40:
          _context.prev = 40;
          _context.t0 = _context['catch'](9);
          _context.next = 44;
          return (0, _effects.call)(logout);

        case 44:
          _context.next = 46;
          return (0, _effects.put)(_authReducer.authActions.initComplete());

        case 46:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[9, 40]]);
}

// check every second to see if there's a login cookie
//  if there isn't then log out
var pollingCookieFlag = false;
function pollLoginState() {
  var loginCookie;
  return _regenerator2.default.wrap(function pollLoginState$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          pollingCookieFlag = true;

        case 1:
          if (!pollingCookieFlag) {
            _context2.next = 16;
            break;
          }

          _context2.next = 4;
          return (0, _effects.call)(_authHelpers.getLoginCookie);

        case 4:
          loginCookie = _context2.sent;

          if (loginCookie) {
            _context2.next = 12;
            break;
          }

          pollingCookieFlag = false;
          _context2.next = 9;
          return (0, _effects.call)(logout);

        case 9:
          return _context2.abrupt('return', _context2.sent);

        case 12:
          _context2.next = 14;
          return (0, _reduxSaga.delay)(1000);

        case 14:
          _context2.next = 1;
          break;

        case 16:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

// finish login once we have a token and have product rights
//  it is the part of the process shared by page-reload
//  and creds login so it is broken out
function completeSuccessfulLogin(loginInfo) {
  var egoHost, userInfo;
  return _regenerator2.default.wrap(function completeSuccessfulLogin$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.select)(_authReducer.authSelectors.egoHost);

        case 3:
          egoHost = _context3.sent;
          _context3.next = 6;
          return (0, _effects.call)(_authHelpers.getUserInfo, loginInfo.userId, loginInfo.access_token, egoHost);

        case 6:
          userInfo = _context3.sent;

          // add roles to user for backward compatibility
          userInfo.roles = loginInfo.roles;
          _context3.next = 10;
          return (0, _effects.put)(_authReducer.authActions.setUserInfo(userInfo));

        case 10:
          _context3.next = 18;
          break;

        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3['catch'](0);
          _context3.next = 16;
          return (0, _effects.put)(_authReducer.authActions.setAuthError(_context3.t0.message));

        case 16:
          _context3.next = 18;
          return (0, _effects.call)(logout);

        case 18:
          _context3.next = 20;
          return (0, _effects.put)(_authReducer.authActions.setAuthToken(loginInfo.access_token));

        case 20:
          _context3.next = 22;
          return (0, _effects.put)(_authReducer.authActions.setRefreshToken(loginInfo.refresh_token));

        case 22:
          _context3.next = 24;
          return (0, _effects.put)(_authReducer.authActions.setLoginStatus(_authReducer.LOGIN_STATUS.LOGGED_IN));

        case 24:
          _context3.next = 26;
          return (0, _effects.put)(_authReducer.authActions.setClientId(loginInfo.client_id));

        case 26:
          _context3.next = 28;
          return (0, _effects.put)(_authReducer.authActions.setProductRights(loginInfo.productRights));

        case 28:
          if (pollingCookieFlag) {
            _context3.next = 31;
            break;
          }

          _context3.next = 31;
          return (0, _effects.spawn)(pollLoginState);

        case 31:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[0, 12]]);
}

function login(action) {
  var username, password, token, tokenResponse, tullyHost, sirenHost, productRightsReponse, appId, loginInfo;
  return _regenerator2.default.wrap(function login$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          username = action.payload.username;
          password = action.payload.password;
          token = action.payload.token;
          _context4.next = 5;
          return (0, _effects.put)(_authReducer.authActions.setLoginStatus(_authReducer.LOGIN_STATUS.PENDING));

        case 5:
          _context4.prev = 5;
          tokenResponse = null;
          _context4.next = 9;
          return (0, _effects.select)(_authReducer.authSelectors.tullyHost);

        case 9:
          tullyHost = _context4.sent;

          if (!token) {
            _context4.next = 16;
            break;
          }

          _context4.next = 13;
          return (0, _effects.call)(_authHelpers.getAccessTokenData, token, tullyHost);

        case 13:
          tokenResponse = _context4.sent;
          _context4.next = 19;
          break;

        case 16:
          _context4.next = 18;
          return (0, _effects.call)(_authHelpers.getAccessTokenWithCreds, username, password, tullyHost);

        case 18:
          tokenResponse = _context4.sent;

        case 19:
          _context4.next = 21;
          return (0, _effects.call)(_authHelpers.saveLoginCookie, tokenResponse.access_token, tokenResponse.userId);

        case 21:
          _context4.next = 23;
          return (0, _effects.select)(_authReducer.authSelectors.sirenHost);

        case 23:
          sirenHost = _context4.sent;
          _context4.next = 26;
          return (0, _effects.call)(_authHelpers.getProductRights, tokenResponse.userId, tokenResponse.access_token, sirenHost);

        case 26:
          productRightsReponse = _context4.sent;
          _context4.next = 29;
          return (0, _effects.select)(_authReducer.authSelectors.appId);

        case 29:
          appId = _context4.sent;
          _context4.next = 32;
          return (0, _effects.call)(_authHelpers.saveStoredLoginInfo, appId, tokenResponse, productRightsReponse.productRights);

        case 32:
          loginInfo = _context4.sent;
          _context4.next = 35;
          return (0, _effects.call)(completeSuccessfulLogin, loginInfo);

        case 35:
          _context4.next = 43;
          break;

        case 37:
          _context4.prev = 37;
          _context4.t0 = _context4['catch'](5);
          _context4.next = 41;
          return (0, _effects.put)(_authReducer.authActions.setAuthError(_context4.t0.message));

        case 41:
          _context4.next = 43;
          return (0, _effects.call)(logout);

        case 43:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[5, 37]]);
}

/*
  If you need to reload the user - say for example you called LPS to
    reset the user's targetLanguage.  LPS does many things so reloading the
    user afterwards is good.

    This expects the user to be successfully logged in and will complain if they are not.

    When completed, it will send the AUTH_INIT_COMPLETE action - wait for that.
 */
function refreshUser() {
  var status, appId;
  return _regenerator2.default.wrap(function refreshUser$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(_authReducer.authSelectors.loginStatus);

        case 2:
          status = _context5.sent;

          if (!(status !== _authReducer.LOGIN_STATUS.LOGGED_IN)) {
            _context5.next = 9;
            break;
          }

          _context5.next = 6;
          return (0, _effects.put)(_authReducer.authActions.setAuthError('attempt to refreshUser with no logged-in user'));

        case 6:
          _context5.next = 8;
          return (0, _effects.put)(_authReducer.authActions.initComplete());

        case 8:
          return _context5.abrupt('return', _context5.sent);

        case 9:
          _context5.next = 11;
          return (0, _effects.select)(_authReducer.authSelectors.appId);

        case 11:
          appId = _context5.sent;
          _context5.next = 14;
          return (0, _effects.call)(_authHelpers.deleteStoredLoginInfo, appId);

        case 14:
          _context5.next = 16;
          return (0, _effects.call)(initializeAuth);

        case 16:
          return _context5.abrupt('return', _context5.sent);

        case 17:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function updateUser(action) {
  var userId, newProps, egoHost, token, currentInfo, newUserInfo;
  return _regenerator2.default.wrap(function updateUser$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.select)(_authReducer.authSelectors.userId);

        case 2:
          userId = _context6.sent;

          if (userId) {
            _context6.next = 7;
            break;
          }

          _context6.next = 6;
          return (0, _effects.put)(_authReducer.authActions.userUpdateComplete());

        case 6:
          return _context6.abrupt('return', _context6.sent);

        case 7:
          newProps = action.payload;
          _context6.next = 10;
          return (0, _effects.select)(_authReducer.authSelectors.egoHost);

        case 10:
          egoHost = _context6.sent;
          _context6.next = 13;
          return (0, _effects.select)(_authReducer.authSelectors.authToken);

        case 13:
          token = _context6.sent;
          _context6.prev = 14;
          _context6.next = 17;
          return (0, _effects.call)(_authHelpers.updateUserInfo, userId, newProps, token, egoHost);

        case 17:
          _context6.next = 19;
          return (0, _effects.select)(_authReducer.authSelectors.userInfo);

        case 19:
          currentInfo = _context6.sent;
          newUserInfo = (0, _extends3.default)({}, currentInfo, newProps);
          _context6.next = 23;
          return (0, _effects.put)(_authReducer.authActions.setUserInfo(newUserInfo));

        case 23:
          _context6.next = 29;
          break;

        case 25:
          _context6.prev = 25;
          _context6.t0 = _context6['catch'](14);
          _context6.next = 29;
          return (0, _effects.put)(_authReducer.authActions.setAuthError(_context6.t0.message));

        case 29:
          _context6.next = 31;
          return (0, _effects.put)(_authReducer.authActions.userUpdateComplete());

        case 31:
          return _context6.abrupt('return', _context6.sent);

        case 32:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this, [[14, 25]]);
}

function logout() {
  var tullyHost, wasSsoUser, userInfo, appId;
  return _regenerator2.default.wrap(function logout$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          pollingCookieFlag = false;
          _context7.prev = 1;
          _context7.next = 4;
          return (0, _effects.select)(_authReducer.authSelectors.tullyHost);

        case 4:
          tullyHost = _context7.sent;
          _context7.next = 7;
          return (0, _effects.call)(_authHelpers.deleteAccessToken, tullyHost);

        case 7:
          _context7.next = 11;
          break;

        case 9:
          _context7.prev = 9;
          _context7.t0 = _context7['catch'](1);

        case 11:
          wasSsoUser = false;
          _context7.next = 14;
          return (0, _effects.select)(_authReducer.authSelectors.userInfo);

        case 14:
          userInfo = _context7.sent;

          if (userInfo) {
            wasSsoUser = userInfo.externalIds && userInfo.externalIds.sso;
          }
          _context7.next = 18;
          return (0, _effects.call)(_authHelpers.deleteLoginCookie);

        case 18:
          _context7.next = 20;
          return (0, _effects.select)(_authReducer.authSelectors.appId);

        case 20:
          appId = _context7.sent;
          _context7.next = 23;
          return (0, _effects.call)(_authHelpers.deleteStoredLoginInfo, appId);

        case 23:
          _context7.next = 25;
          return (0, _effects.put)(_authReducer.authActions.setUserInfo(undefined));

        case 25:
          _context7.next = 27;
          return (0, _effects.put)(_authReducer.authActions.removeAuthToken());

        case 27:
          _context7.next = 29;
          return (0, _effects.put)(_authReducer.authActions.removeRefreshToken());

        case 29:
          _context7.next = 31;
          return (0, _effects.put)(_authReducer.authActions.setLoginStatus(_authReducer.LOGIN_STATUS.LOGGED_OUT));

        case 31:
          _context7.next = 33;
          return (0, _effects.put)(_authReducer.authActions.logoutComplete(wasSsoUser));

        case 33:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this, [[1, 9]]);
}

function authSagas() {
  return _regenerator2.default.wrap(function authSagas$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeLatest)(_authReducer.INIT_AUTH, initializeAuth);

        case 2:
          _context8.next = 4;
          return (0, _effects.takeLatest)(_authReducer.UPDATE_USER, updateUser);

        case 4:
          _context8.next = 6;
          return (0, _effects.takeLatest)(_authReducer.REFRESH_USER, refreshUser);

        case 6:
          _context8.next = 8;
          return (0, _effects.takeLatest)(_authReducer.LOGIN, login);

        case 8:
          _context8.next = 10;
          return (0, _effects.takeEvery)(_authReducer.LOGOUT, logout);

        case 10:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/react-auth/dist/sagas/auth-sagas.js
// module id = 899
// module chunks = 0